/** Landing page that should reclaim sample-page and guest-project Home. */
export const SHEET_MUSIC_SCANNER_PATH = '/sheet-music-scanner';

const GUEST_RETURN_KEY = 'pml.guestReturnTo';

export type SampleArrivalState = {
  from?: string;
};

function isScannerFrom(state: unknown): boolean {
  return (
    state !== null &&
    typeof state === 'object' &&
    'from' in state &&
    (state as SampleArrivalState).from === SHEET_MUSIC_SCANNER_PATH
  );
}

/** Home / upload target after a sample visit. Scanner arrivals go back there. */
export function sampleHomePath(state: unknown): string {
  return isScannerFrom(state) ? SHEET_MUSIC_SCANNER_PATH : '/';
}

/** Persist / clear the guest return path when an upload starts from a landing. */
export function rememberUploadReturnTo(source: string): void {
  try {
    if (source === 'SheetMusicScanner') {
      sessionStorage.setItem(GUEST_RETURN_KEY, SHEET_MUSIC_SCANNER_PATH);
    } else {
      sessionStorage.removeItem(GUEST_RETURN_KEY);
    }
  } catch {
    // Private mode or blocked storage — location.state still covers the hop.
  }
}

/** Router state attached to the project-page navigation after upload. */
export function uploadNavigateState(
  source: string
): SampleArrivalState | undefined {
  return source === 'SheetMusicScanner'
    ? { from: SHEET_MUSIC_SCANNER_PATH }
    : undefined;
}

/** Guest project Home target. Prefers router state, then the upload memory. */
export function guestHomePath(state: unknown): string {
  if (isScannerFrom(state)) return SHEET_MUSIC_SCANNER_PATH;
  try {
    if (sessionStorage.getItem(GUEST_RETURN_KEY) === SHEET_MUSIC_SCANNER_PATH) {
      return SHEET_MUSIC_SCANNER_PATH;
    }
  } catch {
    // ignore
  }
  return '/';
}
